import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loadingIndicator"]
  static values = {
    url: String,
    page: Number,
    hasMore: Boolean
  }

  initialize() {
    this.loading = false
  }

  async onScroll(event) {
    const element = event.target
    const threshold = 100 // pixels from bottom
    const reachedThreshold = element.scrollHeight - element.scrollTop - element.clientHeight <= threshold

    if (reachedThreshold && this.hasMoreValue && !this.loading) {
      this.loading = true
      this.loadingIndicatorTarget.classList.remove("d-none")

      try {
        const nextPage = this.pageValue + 1
        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("page", nextPage)
        
        // Preserve search query if it exists
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("query")) {
          url.searchParams.set("query", searchParams.get("query"))
        }

        const response = await fetch(url, {
          headers: {
            "Accept": "text/vnd.turbo-stream.html"
          }
        })

        if (!response.ok) throw new Error("Failed to fetch more items")

        // Let Turbo handle the stream response
        const html = await response.text()
        
        // Check if the response contains any items
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const hasItems = doc.querySelector('turbo-stream[action="append"]') && 
                         doc.querySelector('turbo-stream[action="append"]').innerHTML.includes('list-group-item');
        
        // Update hasMore based on whether we got any items
        this.hasMoreValue = hasItems;
        
        // Render the stream
        Turbo.renderStreamMessage(html)
        
        // Update the page value
        this.pageValue = nextPage
      } catch (error) {
        console.error("Error loading more items:", error)
        this.hasMoreValue = false;
      } finally {
        this.loading = false
        this.loadingIndicatorTarget.classList.add("d-none")
      }
    }
  }
}
